export default __webpack_public_path__ + "static/media/grafema_pilates_08.6755a8bb.jpg";